import Loading from '@/components/shared/Loading';
export const PortfolioLoading = () => {
  return <div className='mt-32 overflow-clip w-full flex items-center justify-center flex-col' data-sentry-component="PortfolioLoading" data-sentry-source-file="PortfolioLoading.tsx">
      <Loading data-sentry-element="Loading" data-sentry-source-file="PortfolioLoading.tsx" />
      <div className='mb-32 mt-4'>Loading Wallet Balances...</div>
    </div>;
};